import { C } from "../../theme/tokens";

/* Scanner's own card silhouette: two opposite corners cut (top-left +
   bottom-right, like a camera viewfinder) instead of Profile/Signals'
   single-corner ticket cut or Copytrading's notched ticket. Exposed as
   a plain style object (not a wrapper element) so it can be spread
   directly onto whatever element needs it — including a <button>,
   which can't be wrapped in an extra <div> without losing click
   semantics. */
export function scanFrameStyle({ dashed } = {}) {
  return {
    position: "relative",
    clipPath:
      "polygon(16px 0, 100% 0, 100% calc(100% - 16px), calc(100% - 16px) 100%, 0 100%, 0 16px)",
    border: dashed ? `1.5px dashed ${C.hairline}` : `1px solid ${C.hairline}`,
    overflow: "hidden",
  };
}

/* Small viewfinder brackets on the two remaining sharp corners —
   purely decorative, absolutely positioned, so the parent needs
   position: relative (scanFrameStyle already sets that). */
export function ScanCorners() {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          width: 14,
          height: 14,
          borderTop: `2px solid ${C.scanBright}88`,
          borderRight: `2px solid ${C.scanBright}88`,
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 8,
          left: 8,
          width: 14,
          height: 14,
          borderBottom: `2px solid ${C.scanBright}88`,
          borderLeft: `2px solid ${C.scanBright}88`,
          pointerEvents: "none",
        }}
      />
    </>
  );
}
